/* ------------------------------------------------------------------------
Copyright (c) 2016, VoiceVibes, Inc

VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
All contents of this file are proprietary and confidential. No part of
any of the contents of this file may be disclosed in any manner to
a third party without the prior written consent of VoiceVibes, Inc.
Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div>
    <div class="toggleRow row">
      <div class="col-sm-8">
        <h2 class="radioHeader">
          Select Recording Type:
        </h2>
        <label
          class="radioLabel"
        >
          <input
            v-model="recordingType"
            type="radio"
            value="assignment"
          >
          Assignment
        </label>
        <div class="explanatory-text">
          Assignment recordings will be associated with a specific assignment<br>
          and can optionally be shared with the rest of your group.
        </div>
        <br>
        <label
          class="radioLabel"
        >
          <input
            v-model="recordingType"
            type="radio"
            value="private"
          >
          Private
        </label>
        <div class="explanatory-text">
          Private recordings will not be visible to anyone but you. You may add<br>
          a private recording
          to an assignment later, if you wish.
        </div>
      </div>
    </div>

    <br>

    <div
      class="assignment-selection form-group"
    >
      <span
        v-if="recordingType === 'assignment'"
        class="assignmentLabel field-label"
      >
        Assignment
      </span>

      <div
        v-if="recordingType === 'assignment'"
      >
        <div class="sr-only">
          <span>Use the select box to select an assignment</span>
          <label for="screenReaderSelectAssignment">
            Selected Groups/Users:
          </label>
          <select
            id="screenReaderSelectAssignment"
            v-model="screenAssignments"
            multiple
            @change="assignmentChosen"
          >
            <option
              v-for="option in options"
              :value="option.id"
            >
              {{ option.name }}
            </option>
          </select>
        </div>
        <div
          class="assignment-select-container"
          aria-hidden="true"
        >
          <div class="assignment-select">
            <vue-select
              v-model="selected"
              :multiple="false"
              :options="options"
              :searchable="!isSmallViewport"
              label="name"
              :reduce="option => option.id"
              placeholder="select an assignment"
              @input="assignmentInput"
            >
              <template
                slot="option"
                slot-scope="option"
              >
                <div>
                  <div style="display: inline-block; width: 20px; vertical-align: top; padding-top: 4px; margin-left: -10px;">
                    <svg class="icon-file">
                      <use xlink:href="/static/svg-symbols.svg#icon-file" />
                    </svg>
                  </div>
                  <div style="display: inline-block; padding: 3px 0 0 4px;">
                    <strong>{{ option.name }}</strong>
                  </div>
                </div>
              </template>
            </vue-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .icon-file {
    width: 18px;
    height: 18px;
  }

  .radioHeader {
    font-size: 14px;
    font-weight: 600;
  }
  .radioLabel {
    font-size: 14px;
    font-weight: 400;
  }
  div.explanatory-text {
    padding-left: 17px;
    font-size: 11px;
    font-weight: 400;
    color: #999;
  }
  .assignmentLabel {
    padding: 5px 5px 9px 5px;
  }
  .assignment-selection {
    width: 80%;
  }
</style>
<script>
import util from '../utils/util';
import VueSelect from 'vue-select';

export default {
  components: { VueSelect },
  data() {
    return {
      recordingType: 'assignment',
      checkboxValue: 'left',
      userErrors: false,
      selected: null,
      // TODO: Make screenreader stuff work
      screenAssignments: [],
      screenReader: null,
    };
  },
  computed: {
    isSmallViewport: {
      cache: false,
      get: util.isSmallViewport
    },
    groups() {
      return this.$store.getters.activeGroups;
    },
    assignments: {
      cache: false,
      get() {
        return this._.filter(
          this.$store.getters.assignedAssignments,
          (assignment) => this.algorithmOnOrg(assignment)
        );
      }
    },

    options: {
      'cache': false,
      get() {
        let options = [];
        let groupNames = {};

        _.map(this.groups, (g) => {
          groupNames[g.groupId] = g.name;
        });

        _.map(this.assignments, (a) => {
          const groupName = groupNames[a.groupId] || 'Unknown Group';
          const assignmentName = (this.groups.length > 1) ?
            `${a.name} (${groupName})` : a.name;

          options.push({
            name: assignmentName,
            id: a.assignmentId,
            groupId: a.groupId,
          });
        });
        return options;
      }
    },
    /*
    selected: {
      cache: false,
      get() {
        let selected = [];
        if (this.assignment.userTargets && this.assignment.userTargets.length) {
          this.assignment.userTargets.forEach((ut) => {
            selected.push({
              id: ut.userId,
              name: ut.name,
              type: 'user'
            });
          });
        }
        if (this.assignment.groupTargets && this.assignment.groupTargets.length) {
          this.assignment.groupTargets.forEach((gt) => {
            selected.push({
              id: gt.groupId,
              name: 'Group: ' + gt.name,
              type: 'group'
            });
          });
        }
        return selected;
      }
    },
     */
    activeGroups: {
      cache: false,
      get() {
        return this.$store.getters.activeGroups;
      }
    },
    groupMembers: {
      cache: false,
      get() {
        return this.$store.getters.groupMembers;
      }
    },
  },
  methods: {
    algorithmOnOrg(assignment) {
      if (!assignment.criteria || !assignment.criteria.algorithm) {
        return true;
      }
      let supported = false;
      const assignmentAlgorithmFeatureName = assignment.criteria.algorithm.split('-')[1];
      const algorithms = this.$store.getters.org.algorithmConfig.algorithms;
      algorithms.forEach((algo) => {
        const orgAlgorithmFeatureName = algo.name.split('-')[1];
        if (orgAlgorithmFeatureName === assignmentAlgorithmFeatureName) {
          supported = true;
        }
      });
      return supported;
    },
    assignmentInput(option) {
      this.assignment = option;
      this.assignmentChosen();
    },
    assignmentChosen() {
      let assignment;

      if (this.recordingType === 'private') {
        assignment = null;
      } else if (this.assignment) {
        assignment = this._.find(this.assignments, (a) => a.assignmentId === this.assignment.id);
      }

      this.$emit('assignmentChosen', {
        recordingType: this.recordingType,
        assignment,
      });
    },
  }
};
</script>
